import React, { useState } from "react";
import client from "@/lib/api";

const FIELDS = [
  { key: "revenue", label: "Revenue" },
  { key: "cogs", label: "Cost of Goods Sold (COGS)" },
  { key: "overhead", label: "Overhead" },
];

export default function StartingPointEditor({ initial, onSaved, onCancel }) {
  const [vals, setVals] = useState(initial);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      const { data } = await client.put("/me/pnl", vals);
      onSaved(data.pnl);
    } catch {
      setError("Couldn't save your numbers. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-3 rounded-xl border border-[#E5E2DC] bg-white p-4" data-testid="starting-point-editor">
      {FIELDS.map((f) => (
        <div key={f.key}>
          <label className="mb-1 block text-xs font-medium text-neutral-600">{f.label} (annual)</label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400">$</span>
            <input data-testid={`sp-${f.key}-input`} type="number" min="0" value={vals[f.key]}
              onChange={(e) => setVals({ ...vals, [f.key]: Number(e.target.value) || 0 })}
              className="min-h-[42px] w-full rounded-lg border border-neutral-200 pl-7 pr-3 outline-none focus:border-[var(--tenant-primary)]" />
          </div>
        </div>
      ))}
      <p className="text-xs text-neutral-500">Private to you. Ballpark is fine.</p>
      {error && <p className="text-xs text-[#D96C4A]" data-testid="sp-error">{error}</p>}
      <div className="flex gap-2">
        <button data-testid="sp-save-btn" onClick={save} disabled={saving}
          className="rounded-full px-4 py-2 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60"
          style={{ backgroundColor: "var(--tenant-primary)" }}>{saving ? "Saving…" : "Save my numbers"}</button>
        <button data-testid="sp-cancel-btn" onClick={onCancel} className="rounded-full px-4 py-2 text-sm font-medium text-neutral-600 hover:bg-neutral-100">Cancel</button>
      </div>
    </div>
  );
}
